export const devUserOptions = {
	selectedUser: 'vip_coach_basic'
}

const userMap = {
	no_payments : {
		//This account is premium but DOES NOT HAVE PAYMENTS SETUP
		//DO NOT SETUP PAYMENTS ON THIS ACCOUNT
		email:"no_payments@fitsw.com",
		//DO NOT SETUP PAYMENTS ON THIS ACCOUNT
		password:'jjjjjj'
	},
	no_premium_no_access : {
		//this account does not have premium and does not have access because it 
		//was created after we removed the free account
		email:"no_premium_no_access@fitsw.com",
		//DO NOT UPGRADE
		password:'jjjjjj'
	},
	prospect: {
		//do not upgrade this prospect to a client
		email:'test092309230h9h2309h2309h2039h2@fitsw.com',
		password:'$2y$10$DVh5q4vhiiVZj7b2AxDAd.97Bqw/DCIG5Ym1Q4hEezHWuqIedWyJG'
	},
	newAccount : {
		email: "newTrainer@fitsw.com",
		password: "jjjjjj"
	},
	gym : {
		email: "gym@vip.coach",
		password: "jjjjjj"
	},
	//This account is premium but DOES NOT HAVE PAYMENTS SETUP
	//DO NOT SETUP PAYMENTS ON THIS ACCOUNT
	gym_no_payments : {
		//DO NOT SETUP PAYMENTS ON THIS ACCOUNT
		email: "gym_no_payments@fitsw.com",
		//DO NOT SETUP PAYMENTS ON THIS ACCOUNT
		password: "jjjjjj"
	},
	gym_trainer : {
		email:'gym-trainer@vip.coach',
		password:'jjjjjj'
	},
	richard : {
		email: "richard@fitsw.com",
		password: "jjjjjj"
	},
	chain : {
		email:'chain@fitsw.com',
		password:'jjjjjj',
		//route:'/chain'
	},
	not_shared : {
		email:'not_shared@fitsw.com',
		password:'jjjjjj'
	},
	testAccount : {
		email:'testAccount@fitsw.com',
		password:'jjjjjj'
	},
	ac : {
		email:'ac@fitsw.com',
		password:'jjjjjj'
	},
	ob : {
		email:'ob@fitsw.com',
		password:'jjjjjj'
	},
	'test-1' : {
		email:'test-payouts-1@fitsw.com',
		password:'jjjjjj'
	},
	julia : {
		email:'julia@fitsw.com',
		password:'jjjjjj'
	},
	event_limit : {
		email:'event_limit_test@fitsw.com',
		password:'jjjjjj'
	},
	test2 : {
		email:'test2039402834092834092384@fitsw.com',
		password:'jjjjjj'
	},
	free : {
		email:'free_trainer@fitsw.com',
		password:'jjjjjj'
	},
	vip_coach_basic : {
		email:'coach@vip.coach',
		password:'jjjjjj'
	}
}

export default userMap